import { MgItemCardDTO } from '../../dto';
import { MgItemPackage } from './MgItemPackage';
import { MgItemPackages } from './MgItemPackageValues';
import { MgSupplierItemCard } from './MgSupplierItemCard';

interface Props {
  mgItemNumber: number;
  replacedByMgItemNumber?: number;
  mgSupplierItems: MgSupplierItemCard[];
  mgPackages: MgItemPackage[];
}

export class MgItemCard {
  mgItemNumber: number;
  replacedByMgItemNumber?: number;
  mgSupplierItems: MgSupplierItemCard[];
  mgPackages: MgItemPackage[];

  constructor({ mgItemNumber, replacedByMgItemNumber, mgSupplierItems, mgPackages }: Props) {
    this.mgItemNumber = mgItemNumber;
    this.replacedByMgItemNumber = replacedByMgItemNumber;
    this.mgSupplierItems = mgSupplierItems;
    this.mgPackages = mgPackages;
  }

  getSupplierItem = (supplierId: number): MgSupplierItemCard | undefined =>
    this.mgSupplierItems.find(
      (supplierItem) => supplierItem.mgSupplier.mgSupplierId === supplierId
    );

  getSuppliers = (): Partial<MgSupplierItemCard>[] =>
    this.mgSupplierItems.map((supplierItem) => ({
      mgSupplier: supplierItem.mgSupplier,
      mgSupplierItemId: supplierItem.mgSupplierItemId,
    })) ?? [];

  getFirstSupplierItem(): MgSupplierItemCard {
    return this.mgSupplierItems[0];
  }

  getPackages(): MgItemPackages {
    // @ts-ignore
    const uniquePackages: MgItemPackages = {};

    for (const pkg of this.mgPackages) {
      const packageType = pkg.packageType;

      if (packageType) {
        if (!uniquePackages[packageType]) uniquePackages[packageType] = [];

        const newPackage = {
          gtinCode: pkg.gtinCode,
          unit: pkg.unit,
          isBasePriceUnit: pkg.isBasePriceUnit,
          calculatedCount: pkg.calculatedCount,
          packageType: pkg.packageType,
          classCode: pkg.classCode,
        };

        // Check if the package already exists in the array
        const packageExists = uniquePackages[packageType].some(
          (existingPackage) => existingPackage.gtinCode === newPackage.gtinCode
        );

        if (!packageExists) uniquePackages[packageType].push(newPackage as MgItemPackage);
      }
    }

    return uniquePackages;
  }

  static fromDto = (dto: MgItemCardDTO): MgItemCard =>
    new MgItemCard({
      mgItemNumber: dto.mgItemNumber,
      replacedByMgItemNumber: dto.replacedByMgItemNumber,
      mgSupplierItems: dto.mgSupplierItems.map(MgSupplierItemCard.fromDto),
      mgPackages: dto.mgPackages.map(MgItemPackage.fromDto),
    });
}
